import { Pipe, PipeTransform } from '@angular/core';

import { isValue, strToNumber } from '../../helpers/common';
import { formatNumber } from '../format-number';

@Pipe({
  name: 'number'
})
export class NumberPipe implements PipeTransform {
  transform(value: number|string|null|undefined, digitsInfo?: string): string {
    if (!isValue(value)) {
      return '';
    }

    try {
      const num = strToNumber(value);

      return formatNumber(num, digitsInfo);
    } catch (e: any) {
      throw new Error(e?.message || 'Undefined format number error');
    }
  }
}